import { Component, OnInit } from '@angular/core';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { loadSpecialProducts } from '@app/actions/shoppingmall/product.action';
import { AuthUtil } from '@app/common/util/auth.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { ProductState, getSpecialProducts } from '@app/selectors/shoppingmall/product.selector';
import { SmWownetState, getSmWownet } from '@app/selectors/system/sm-wownet.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

declare const recomProductSwiper: any;

@Component({
  selector: 'hp-recommend',
  templateUrl: './hp-recommend.component.html',
  styleUrls: ['./hp-recommend.component.css']
})
export class HpRecommendComponent implements OnInit {

  smWownet$ = new Observable<SmWownetModel>();
  smWownet: any = {} as SmWownetModel;
  urlWownet : String = "";

  products$ = new Observable<OrdPdtModel[]>();
  products: OrdPdtModel[] = [];

  mapPdt: Map<Number, OrdPdtModel[]> = new Map();

  pathKind: string = "PC";
  page: number = 1;
  len: number = 100;

  isLogined: boolean = false;

  constructor(
    private _smWownetStateStore: Store<SmWownetState>,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _productStore: Store<ProductState>,
  ) { 
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    this.products$ = this._productStore.select(getSpecialProducts);
  }

  ngOnInit(): void {

    this.smWownet$.subscribe((res) => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.urlWownet = res.urlWownet;
          this.smWownet = res;
      }
    });

    this.loadProducts();
    this.isLogined = AuthUtil.isLogined();


    this.products$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        let lenSwiper = Math.ceil(+res.length/5);
        let tmpLen = 0;
        this.mapPdt = new Map(); 
        this.products = res;
        
        for(let i=0; i<lenSwiper; i++) {
          let tmp = []
          for(let j=tmpLen; j<tmpLen+5; j++) {
            if(j < res.length) {
              tmp.push(res[j])
            }
          }
          tmpLen += 5;
          this.mapPdt.set(i, tmp);
        }     
      }

      setTimeout(() => {
        recomProductSwiper();
      }, 500);
    });
  }

  loadProducts(): void {
    const params = this.getParams();

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._productStore.dispatch(loadSpecialProducts({ params: params }));
  }

  getParams(): any {

    const params = {
      comId: environment.comId,
      cateCd: '',
      pathKind: this.pathKind,
      type: '2',
      userId: AuthUtil.getUserId(),
      page: this.page - 1,
      len: this.len,
    }

    return params;
  }
}
